import axios from "axios";
import { API_URL } from "./config";
import { getIdToken, refreshToken } from "./auth";
import { v4 as uuidv4 } from "uuid";
import { jwtDecode } from "jwt-decode";

const axiosInstance = axios.create({
  baseURL: API_URL,
  validateStatus: function (status) {
    return (status >= 200 && status < 300) || [400, 404, 422].includes(status);
  },
});

const getSessionToken = () => {
  let sessionToken = sessionStorage.getItem("x-session-token");
  if (!sessionToken) {
    sessionToken = uuidv4();
    sessionStorage.setItem("x-session-token", sessionToken);
  }
  return sessionToken;
};

const getUserOid = (token) => {
  let userOid = sessionStorage.getItem("x-oid");
  if (!userOid) {
    const decodedToken = jwtDecode(token);
    userOid = decodedToken.oid;
    sessionStorage.setItem("x-oid", userOid);
  }

  return userOid;
};

axiosInstance.interceptors.request.use(async (config) => {
  const token = await getIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers["x-oid"] = getUserOid(token);
  }
  config.headers["x-originating-pathname"] = window.location.pathname;
  config.headers["x-session-token"] = getSessionToken();
  return config;
}, Promise.reject);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const newToken = await refreshToken();
      if (newToken) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);

export const getWebsocketUrl = async (relativeUrl) => {
  let baseUrl = API_URL.replace("http", "ws");
  if (!baseUrl.endsWith("/")) {
    baseUrl += "/";
  }
  if (relativeUrl.startsWith("/")) {
    relativeUrl = relativeUrl.substring(1);
  }
  const token = await getIdToken();
  return `${baseUrl}${relativeUrl}?token=${token}`;
};

export default axiosInstance;
